import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var CompositionAttributeRange = /** @class */ (function (_super) {
    __extends(CompositionAttributeRange, _super);
    function CompositionAttributeRange(relativeStart /*int*/, relativeEnd /*int*/, selected, converted) {
        var _this = this;
        relativeStart = relativeStart | 0;
        relativeEnd = relativeEnd | 0;
        selected = !!selected;
        converted = !!converted;
        _this = _super.call(this) || this;
        return _this;
    }
    // Called whenever the class is initialized.
    CompositionAttributeRange.classInitializer = null;
    // List of static symbols to link.
    CompositionAttributeRange.classSymbols = null; // [];
    // List of instance symbols to link.
    CompositionAttributeRange.instanceSymbols = null; // ["relativeStart", "relativeEnd", "selected", "converted"];
    return CompositionAttributeRange;
}(ASObject));
export { CompositionAttributeRange };
